
import AiButton from './ai-button.vue'

export default {
  components: {AiButton},
  props: {
    options: {type: Array, required: true},
    answer: {type: Object, default: undefined},
  },
  emits: ['prompt'],
  data(){
    return {
      // TODO: In onboarding answer is not saved, so we need 
      // to use selected_idx to track the current selection
      // Should be removed after onboarding is refactored to 
      // save answers in the history
      selected_idx: -1,
    }
  },
  computed: {
    selected() {
      if (this.answer) {
        return this.options.findIndex(item => item.chat_query.text === this.answer.text)
      }
      return this.selected_idx
    }
  },
  methods: {
    onSelected(idx, item) {
      this.selected_idx = idx
      this.$emit('prompt', item.chat_query)
    }
  }
}
